import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { EventType } from "pages/statuses/EventType";
import { CollectionRequestForm } from "pages/booking/dialogParts/CollectionRequestForm";
import { WasteChemicals } from "pages/booking/dialogParts/WasteChemicals";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            margin: theme.spacing(5),
            marginBottom: theme.spacing(1),
            color: `black`,
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
    // ローディング状態のセッター
    setLoading: any;
}

/**
 * 回収依頼票編集コンポーネント
 */
export const SubscribeForm: React.FC<Props> = (props) => {
    const { booking, setLoading } = props;
    const classes = useStyles();

    return (
        <div className={classes.form}>
            <CollectionRequestForm booking={booking} mode={`edit`} setLoading={setLoading} />
            <WasteChemicals booking={booking} mode={`edit`} setLoading={setLoading} />
        </div>
    );
};
